<script setup>
import { onMounted } from "vue"; 


onMounted(() => {
  const mapContainer = document.querySelector('.map-container');
  mapContainer.addEventListener('scroll', () => {
    mapContainer.style.setProperty('--scroll', `${mapContainer.scrollLeft / (mapContainer.scrollWidth - mapContainer.offsetWidth) * 100}%`);
  });
  // Create map instance
  var chart = am4core.create("map", am4maps.MapChart);

  // Set map definition
  chart.geodata = am4geodata_worldLow;

  // Set projection
  chart.projection = new am4maps.projections.Miller();

  // Create map polygon series
  var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

  // Exclude Antartica
  polygonSeries.exclude = ["AQ"];

  // Make map load polygon (like country names) data from GeoJSON
  polygonSeries.useGeodata = true;

  // Configure series
  var polygonTemplate = polygonSeries.mapPolygons.template;
  polygonTemplate.tooltipText = "{name}";
  polygonTemplate.fill = am4core.color("#ffffff");

  // Add border for each country
  polygonTemplate.stroke = am4core.color("#D9D9D9");
  polygonTemplate.strokeWidth = 1;

  // Create hover state and set alternative fill color
  var hs = polygonTemplate.states.create("hover");
  hs.properties.fill = am4core.color("#D9D9D9");

  chart.chartContainer.wheelable = false;

  // Disable zooming and panning on mobile
  chart.chartContainer.wheelable = false;
  chart.seriesContainer.draggable = false;
  chart.seriesContainer.resizable = false;
  
  // Create map image series
  var imageSeries = chart.series.push(new am4maps.MapImageSeries());

  // Create map image
  var imageSeriesTemplate = imageSeries.mapImages.template;
  var circle = imageSeriesTemplate.createChild(am4core.Circle);
  circle.radius = 6;
  circle.fill = am4core.color("#FF9841");
  circle.stroke = am4core.color("#FFFFFF");
  circle.strokeWidth = 2;
  circle.nonScaling = true;
  circle.tooltipText = "{title}";

  // Set property fields
  imageSeriesTemplate.propertyFields.latitude = "latitude";
  imageSeriesTemplate.propertyFields.longitude = "longitude";

  // Set data
  var cities = [
    { title: "Paris", latitude: 48.856744, longitude: 2.3514226 },
    { title: "Ecublens", latitude: 46.5285839, longitude: 6.5240907 },
    { title: "Hanoi", latitude: 21.0227384, longitude: 105.8163641 },
    { title: "Ho Chi Minh City", latitude: 10.7546181, longitude: 106.3655708 },
    { title: "Sydney", latitude: -33.8478053, longitude: 150.6023296 },
    { title: "New York", latitude: 40.6970193, longitude: -74.3093208 },
    { title: "Los Angeles", latitude: 34.0200393, longitude: -118.7413776 },
  ];

  // Add data to image series
  imageSeries.data = cities;
});

</script>

<template>
  <section class="rounded-[48px] relative">
    <div class="map-container">
        <div data-aos="fade-up" id="map"></div>
    </div>
  </section>
</template>

<style>
#map {
  width: 100%;
  height: 100vh;
}
@media only screen and (max-width: 768px){
  #map {
    width: 200%;
    height: 50vh;
  }
  .map-container {
    display: block;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .map-container::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: #FFFFFF;
    border-radius: 4px;
  }

  .map-container::-webkit-scrollbar-thumb {
    background: #F67D30;
    border-radius: 4px;
  }
}
</style>
